<template>
  <div class="modal-overlay" ref="refRoot" tabindex="0" @mousedown="onMouseDown" @mouseup="onMouseUp">
    <div class="modal-content" :class="{ 'move-up': moveUp }">
      <header>
        <h3>{{ title }}</h3>
        <!--모달 타이틀-->
        <div class="close-icon">
          <CloseIcon @click="closeModal" />
        </div>
      </header>
      <main>
        <slot></slot>
        <!--모달 내용-->
      </main>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, ref } from 'vue';

import CloseIcon from '@/components/icons/IconClose.vue';
import { useKeyPress } from '@/composables/shared/useKeyPress';

const emit = defineEmits(['close']);

const props = defineProps({
  title: {
    type: String,
    default: '크레딧 구매하기',
  },
  moveUp: {
    type: Boolean,
    default: true,
  },
});

const refRoot = ref<HTMLElement | null>(null);
let mouseDownTarget: EventTarget | null = null;

const onMouseDown = (e: MouseEvent) => {
  mouseDownTarget = e.target;
};

const onMouseUp = (e: MouseEvent) => {
  if (e.target === e.currentTarget && mouseDownTarget === e.currentTarget) {
    closeModal();
  }
};

const closeModal = () => {
  emit('close');
};

useKeyPress(refRoot, {
  Escape: () => {
    closeModal();
  },
});

onMounted(() => {
  refRoot.value?.focus();
  document.body.style.overflow = 'hidden';
});

onUnmounted(() => {
  document.body.style.overflow = '';
});
</script>

<style scoped lang="scss">
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--surface-glass-dark);
  backdrop-filter: $blur-medium;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1500;
}

.modal-content {
  position: relative;
  width: 100%;
  max-width: 800px;
  max-height: 90dvh;
  height: fit-content;
  min-height: 20rem;
  border-radius: 1.5rem;
  background: var(--surface-overlay);
  box-shadow: $shadow-modal;
  overflow: hidden;
}

main {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  padding: 0.75rem 1.5rem 0 1.5rem;
  overflow-y: auto;
  max-height: calc(90dvh - 2.75rem);
  padding-bottom: 1.25rem;
}

header {
  display: flex;
  justify-content: space-between;
  padding: 1.25rem;
  h3 {
    color: $color-gray-700;
    font-size: $font-size-h6;
  }
  .close-icon {
    display: flex;
    cursor: pointer;
    width: 1.5rem;
    height: 1.5rem;
    svg {
      color: $color-gray-700;
    }
  }
}

@media (min-width: 768px) {
  .tab-container {
    margin-top: 0;
  }
  .modal-content {
    main {
      &::-webkit-scrollbar {
        display: none;
      }
    }
  }
}

.move-up {
  transition: transform 0.3s ease-in-out;
}
</style>
